// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ApplyConfigurationCard_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], config: { __typename?: 'CheckoutConfigSide', exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, productOffering?: { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined } };

export const ApplyConfigurationCard_CheckoutConfigFragmentDoc = gql`
    fragment ApplyConfigurationCard_CheckoutConfig on CheckoutConfig {
  id
  name
  updatedAt
  config: sideFor(structureId: $structureId) {
    productOffering {
      id
      name
      code
      coverAsset {
        id
        previewUrl(resizing: {width: 321, region: FULL})
      }
    }
    aggregateVersion {
      id
      displayVersion
    }
    exteriorOptionNames
    interiorOptionNames
  }
}
    `;